/* eslint-disable */
// @ts-nocheck

export function initUploader() {
	window.bynder?.elements?.UploadButton?.initialize();
}
